const ls = window.localStorage;
const ss = window.sessionStorage;

export const Local = {
  get(key) {
      const val = ls.getItem(key);
      if (key && val) {
        try {
          return JSON.parse(val);
        } catch(e) {
          return val;
        }
      }
      return null;
  },
  set(key, val) {
    const setting = arguments[0];
    if (Object.prototype.toString.call(setting).slice(8, -1) === 'Object') {
      for (const i in setting) {
        ls.setItem(i, JSON.stringify(setting[i]));
      }
    } else {
      ls.setItem(key, JSON.stringify(val));
    }
  },
  remove(key) {
    ls.removeItem(key);
  },
  clear() {
    ls.clear();
  }
};
export const Session = {
  get(key) {
    const val = ss.getItem(key);
    if (key && val) {
      try {
        return JSON.parse(val);
      } catch(e) {
        return val;
      }
    }
    return null;
  },
  set(key, val) {
    const setting = arguments[0];
    if (Object.prototype.toString.call(setting).slice(8, -1) === 'Object') {
      for (const i in setting) {
        ss.setItem(i, JSON.stringify(setting[i]));
      }
    } else {
      ss.setItem(key, JSON.stringify(val));
    }
  },
  remove(key) {
    ss.removeItem(key);
  },
  clear() {
    ss.clear();
  }
};



// WEBPACK FOOTER //
// ./src/js/util/storage.js